// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blogList {
  background: #fff none repeat scroll 0 0;
  position: relative;
  max-width: 280px;
  margin: 30px auto;
  box-shadow: -6px 10px 40px rgba(0, 0, 0, 0.06);
  display: block;
  color: #5b5963 !important;
  transition: all 0.3s ease 0s;
  position: relative;
  font-size: inherit;
  text-indent: 0; }

.blogList-desc {
  padding: 25px 20px;
  font: 400 12px/1.8 'Poppins', sans-serif; }

.blogList:hover {
  text-decoration: none; }

.blogList-img {
  position: relative; }

.blogList-img img,
.blog-wrapper.list-items-container .list-item img {
  height: 240px;
  width: 100%;
  object-fit: cover; }

.blogList-img span {
  position: absolute;
  right: 10px;
  bottom: 10px;
  background: #fff;
  padding: 3px 10px;
  border-radius: 3px;
  box-shadow: -6px 10px 40px rgba(0, 0, 0, 0.06);
  color: #429f98;
  transition: all 0.5s ease 0s;
  text-transform: capitalize;
  font: 400 12px/1.8 'Poppins', sans-serif; }

.list-items-container.blog-wrapper .list-item {
  margin-bottom: 0; }

.blog-detail-contents {
  max-width: 800px;
  margin: -100px auto 0px;
  background: #fff;
  display: block;
  padding: 30px;
  z-index: 11;
  position: relative;
  border-radius: 10px; }

.blog-detail-content p {
  margin: 15px 0; }

.blog-detail-content h3 {
  margin: 20px 0; }

.blog-detail-content h2 {
  margin: 25px 0; }

.blog-detail-content blockquote {
  font-size: 13px;
  background: #f5f5f5;
  border-color: #fd735a; }

.blog-detail-content blockquote p {
  margin: 0; }

.blog-detail-content img {
  width: 100%;
  margin: 15px 0;
  height: 350px;
  object-fit: cover; }

.blog-detail-about .media-body {
  width: auto; }

.blog-detail-about .media-body p {
  margin: 0; }

.blog-detail-about .media {
  margin-bottom: 20px; }

.blog-detail-about img.media-object {
  border-radius: 5px;
  height: 60px;
  width: 60px; }

.media-body,
.media-left,
.media-right {
  vertical-align: middle; }

.blog-detail-category {
  padding: 3px 15px;
  color: #fff;
  text-transform: capitalize;
  background: #fd735a;
  border-radius: 2px;
  margin: 15px 0; }

.blog-detail-banner img {
  height: 400px;
  width: 100%;
  object-fit: cover; }

.blog-detail-tags ul {
  margin: 0;
  padding: 0; }

.blog-detail-tags ul li {
  display: inline-block; }

.tags {
  display: inline-block;
  padding: 4px 10px;
  background-color: #f5f5f5;
  color: #5b5963;
  margin-right: 5px;
  text-transform: capitalize;
  margin-bottom: 10px; }

.tags:hover {
  background-color: #fd735a;
  color: #ffffff; }

.blog-detail-sib {
  padding: 40px 0 20px; }

.blog-detail-sib .blog-nav span {
  display: block;
  color: #5b5963; }

.blog-detail-sib .blog-nav p {
  font-size: 18px;
  color: #5b5963;
  margin: 0; }

.blog-nav {
  padding: 10px;
  background: #f5f5f5;
  transition: all 0.125s ease-in-out 0s;
  display: block;
  border-radius: 3px; }

.blog-nav:hover {
  background: #fd735a;
  color: #fff; }

.blog-nav:hover p,
.blog-nav:hover span {
  color: #fff; }

.blogList:hover {
  margin-top: 25px; }

.blogList:hover .blogList-img span {
  background: #116466;
  color: #fff; }

.blogList-desc h3 {
  margin-bottom: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; }

.blog-viewMore {
  display: block;
  font: 400 13px/1.2 'Poppins', sans-serif;
  text-transform: uppercase;
  text-decoration: none;
  letter-spacing: 1px;
  padding: 10px 20px;
  margin: 5px;
  cursor: pointer;
  transition: all 0.4s ease-in-out 0s;
  background: #fd735a;
  color: #fff;
  max-width: 170px;
  margin: 10px auto;
  text-align: center; }

.blog-viewMore:hover {
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  color: #fff; }

.blog-items-container {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0; }

.blog-item {
  display: block;
  list-style: outside none none;
  margin-bottom: 20px;
  overflow: hidden;
  padding: 0 10px;
  width: 33.333%;
  transition: opacity 0.35s ease 0s, transform 0.35s ease 0s; }
`, "",{"version":3,"sources":["webpack://./src/store/components/blogPosts/index.scss"],"names":[],"mappings":"AAAA;EACI,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc,EAAA;;AAGlB;EACI,kBAAkB;EAClB,wCAAwC,EAAA;;AAG5C;EACI,qBAAqB,EAAA;;AAEzB;EACI,kBAAkB,EAAA;;AAGtB;;EAEI,aAAa;EACb,WAAW;EACX,iBAAiB,EAAA;;AAGrB;EACI,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8CAA8C;EAC9C,cAAc;EACd,4BAA4B;EAC5B,0BAA0B;EAC1B,wCAAwC,EAAA;;AAG5C;EACI,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mBAAmB,EAAA;;AAGvB;EACI,cAAc,EAAA;;AAGlB;EACI,cAAc,EAAA;;AAGlB;EACI,cAAc,EAAA;;AAGlB;EACI,eAAe;EACf,mBAAmB;EACnB,qBAAmC,EAAA;;AAGvC;EACI,SAAS,EAAA;;AAGb;EACI,WAAW;EACX,cAAc;EACd,aAAa;EACb,iBAAiB,EAAA;;AAGrB;EACI,WAAW,EAAA;;AAGf;EACI,SAAS,EAAA;;AAGb;EACI,mBAAmB,EAAA;;AAGvB;EACI,kBAAkB;EAClB,YAAY;EACZ,WAAW,EAAA;;AAGf;;;EAGI,sBAAsB,EAAA;;AAG1B;EACI,iBAAiB;EACjB,WAAW;EACX,0BAA0B;EAC1B,mBAAiC;EACjC,kBAAkB;EAClB,cAAc,EAAA;;AAGlB;EACI,aAAa;EACb,WAAW;EACX,iBAAiB,EAAA;;AAGrB;EACI,SAAS;EACT,UAAU,EAAA;;AAGd;EACI,qBAAqB,EAAA;;AAGzB;EACI,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB,EAAA;;AAGvB;EACI,yBAAuC;EACvC,cAAc,EAAA;;AAGlB;EACI,oBAAoB,EAAA;;AAGxB;EACI,cAAc;EACd,cAAc,EAAA;;AAGlB;EACI,eAAe;EACf,cAAc;EACd,SAAS,EAAA;;AAGb;EACI,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,kBAAkB,EAAA;;AAGtB;EACI,mBAAiC;EACjC,WAAW,EAAA;;AAGf;;EAEI,WAAW,EAAA;;AAGf;EACI,gBAAgB,EAAA;;AAGpB;EACI,mBAAmB;EACnB,WAAW,EAAA;;AAGf;EACI,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB,EAAA;;AAG3B;EACI,cAAc;EACd,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EAKf,mCAAmC;EACnC,mBAAiC;EACjC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB,EAAA;;AAGtB;EACI,4CAA4C;EAC5C,WAAW,EAAA;;AAGf;EACI,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS,EAAA;;AAGb;EACI,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EAKd,0DAA0D,EAAA","sourcesContent":[".blogList {\n    background: #fff none repeat scroll 0 0;\n    position: relative;\n    max-width: 280px;\n    margin: 30px auto;\n    box-shadow: -6px 10px 40px rgba(0, 0, 0, 0.06);\n    display: block;\n    color: #5b5963 !important;\n    transition: all 0.3s ease 0s;\n    position: relative;\n    font-size: inherit;\n    text-indent: 0;\n}\n\n.blogList-desc {\n    padding: 25px 20px;\n    font: 400 12px/1.8 'Poppins', sans-serif;\n}\n\n.blogList:hover {\n    text-decoration: none;\n}\n.blogList-img {\n    position: relative;\n}\n\n.blogList-img img,\n.blog-wrapper.list-items-container .list-item img {\n    height: 240px;\n    width: 100%;\n    object-fit: cover;\n}\n\n.blogList-img span {\n    position: absolute;\n    right: 10px;\n    bottom: 10px;\n    background: #fff;\n    padding: 3px 10px;\n    border-radius: 3px;\n    box-shadow: -6px 10px 40px rgba(0, 0, 0, 0.06);\n    color: #429f98;\n    transition: all 0.5s ease 0s;\n    text-transform: capitalize;\n    font: 400 12px/1.8 'Poppins', sans-serif;\n}\n\n.list-items-container.blog-wrapper .list-item {\n    margin-bottom: 0;\n}\n\n.blog-detail-contents {\n    max-width: 800px;\n    margin: -100px auto 0px;\n    background: #fff;\n    display: block;\n    padding: 30px;\n    z-index: 11;\n    position: relative;\n    border-radius: 10px;\n}\n\n.blog-detail-content p {\n    margin: 15px 0;\n}\n\n.blog-detail-content h3 {\n    margin: 20px 0;\n}\n\n.blog-detail-content h2 {\n    margin: 25px 0;\n}\n\n.blog-detail-content blockquote {\n    font-size: 13px;\n    background: #f5f5f5;\n    border-color: rgba(253, 115, 90, 1);\n}\n\n.blog-detail-content blockquote p {\n    margin: 0;\n}\n\n.blog-detail-content img {\n    width: 100%;\n    margin: 15px 0;\n    height: 350px;\n    object-fit: cover;\n}\n\n.blog-detail-about .media-body {\n    width: auto;\n}\n\n.blog-detail-about .media-body p {\n    margin: 0;\n}\n\n.blog-detail-about .media {\n    margin-bottom: 20px;\n}\n\n.blog-detail-about img.media-object {\n    border-radius: 5px;\n    height: 60px;\n    width: 60px;\n}\n\n.media-body,\n.media-left,\n.media-right {\n    vertical-align: middle;\n}\n\n.blog-detail-category {\n    padding: 3px 15px;\n    color: #fff;\n    text-transform: capitalize;\n    background: rgba(253, 115, 90, 1);\n    border-radius: 2px;\n    margin: 15px 0;\n}\n\n.blog-detail-banner img {\n    height: 400px;\n    width: 100%;\n    object-fit: cover;\n}\n\n.blog-detail-tags ul {\n    margin: 0;\n    padding: 0;\n}\n\n.blog-detail-tags ul li {\n    display: inline-block;\n}\n\n.tags {\n    display: inline-block;\n    padding: 4px 10px;\n    background-color: #f5f5f5;\n    color: #5b5963;\n    margin-right: 5px;\n    text-transform: capitalize;\n    margin-bottom: 10px;\n}\n\n.tags:hover {\n    background-color: rgba(253, 115, 90, 1);\n    color: #ffffff;\n}\n\n.blog-detail-sib {\n    padding: 40px 0 20px;\n}\n\n.blog-detail-sib .blog-nav span {\n    display: block;\n    color: #5b5963;\n}\n\n.blog-detail-sib .blog-nav p {\n    font-size: 18px;\n    color: #5b5963;\n    margin: 0;\n}\n\n.blog-nav {\n    padding: 10px;\n    background: #f5f5f5;\n    transition: all 0.125s ease-in-out 0s;\n    display: block;\n    border-radius: 3px;\n}\n\n.blog-nav:hover {\n    background: rgba(253, 115, 90, 1);\n    color: #fff;\n}\n\n.blog-nav:hover p,\n.blog-nav:hover span {\n    color: #fff;\n}\n\n.blogList:hover {\n    margin-top: 25px;\n}\n\n.blogList:hover .blogList-img span {\n    background: #116466;\n    color: #fff;\n}\n\n.blogList-desc h3 {\n    margin-bottom: 15px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.blog-viewMore {\n    display: block;\n    font: 400 13px/1.2 'Poppins', sans-serif;\n    text-transform: uppercase;\n    text-decoration: none;\n    letter-spacing: 1px;\n    padding: 10px 20px;\n    margin: 5px;\n    cursor: pointer;\n    -webkit-transition: all 0.4s ease-in-out 0s;\n    -moz-transition: all 0.4s ease-in-out 0s;\n    -ms-transition: all 0.4s ease-in-out 0s;\n    -o-transition: all 0.4s ease-in-out 0s;\n    transition: all 0.4s ease-in-out 0s;\n    background: rgba(253, 115, 90, 1);\n    color: #fff;\n    max-width: 170px;\n    margin: 10px auto;\n    text-align: center;\n}\n\n.blog-viewMore:hover {\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);\n    color: #fff;\n}\n\n.blog-items-container {\n    position: relative;\n    display: block;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n}\n\n.blog-item {\n    display: block;\n    list-style: outside none none;\n    margin-bottom: 20px;\n    overflow: hidden;\n    padding: 0 10px;\n    width: 33.333%;\n    -webkit-transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;\n    -moz-transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;\n    -ms-transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;\n    -o-transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;\n    transition: opacity 0.35s ease 0s, transform 0.35s ease 0s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
